/* Hide the Tawk.to chat bubble while a drawer or the Klaviyo flyout is open.
   The bubble is pinned bottom-left and sits on top of every drawer, so it
   covered the filter drawer's "Clear All", the cart drawer's "View cart &
   checkout", the menu drawer's footer links and the mobile Klaviyo sign-up
   flyout (docked to the bottom). Tawk positions itself with
   inline !important styles, so CSS can't move it — use its JS API instead.
   Never hides a chat the customer has open, and only re-shows what we hid. */
(function () {
  var hiddenByUs = false;
  // Set from Klaviyo's documented `klaviyoForms` window event (open/close).
  var klaviyoFlyoutOpen = false;

  function anyDrawerOpen() {
    var cart = document.getElementById('CartDrawer');
    if (cart && cart.classList.contains('is-open')) return true;
    if (document.querySelector('.tfs-hdr .drawer.open')) return true;
    // Fitment filter drawer is appended to <body> only while open.
    if (document.querySelector('body > .tfs-drawer')) return true;
    if (klaviyoFlyoutOpen) return true;
    return false;
  }

  function sync() {
    var api = window.Tawk_API;
    if (!api || typeof api.hideWidget !== 'function') return;
    var open = anyDrawerOpen();
    if (open && !hiddenByUs) {
      if (typeof api.isChatMaximized === 'function' && api.isChatMaximized()) return;
      api.hideWidget();
      hiddenByUs = true;
    } else if (!open && hiddenByUs) {
      api.showWidget();
      hiddenByUs = false;
    }
  }

  function start() {
    var mo = new MutationObserver(sync);
    // Drawer appends/removals on <body>, plus class flips on the two
    // persistent drawers — not the whole subtree (the product grid churns).
    mo.observe(document.body, { childList: true });
    var cart = document.getElementById('CartDrawer');
    if (cart) mo.observe(cart, { attributes: true, attributeFilter: ['class'] });
    var menu = document.querySelector('.tfs-hdr .drawer');
    if (menu) mo.observe(menu, { attributes: true, attributeFilter: ['class'] });

    // Klaviyo renders the flyout deep inside its own container (invisible to
    // the body childList observer), so key off its form events instead. Only
    // flyouts matter — the desktop popup is centred and clear of the bubble.
    window.addEventListener('klaviyoForms', function (e) {
      var type = e.detail && e.detail.type;
      if (type === 'open') {
        // The open event can fire before the flyout is in the DOM.
        setTimeout(function () {
          klaviyoFlyoutOpen = !!document.querySelector('[data-testid="FLYOUT"]');
          sync();
        }, 300);
      } else if (type === 'close') {
        klaviyoFlyoutOpen = false;
        sync();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
